import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { English, Spanish } from '../../localization/Languages'
import { fetchFilterFundLists } from "../../utilities/dashboardServices";

export const fetchFilterFund = createAsyncThunk(
    "filterFund",
    fetchFilterFundLists
);

const initialState = {
    loader: false
}

const filterFundSlice = createSlice({
    name: 'languages',
    initialState,
    reducers: {
        languages: (state, action) => {
            state.language = action.payload ? Spanish : English
            state.checkedStatus = action.payload
        },
        resetLanguages: (state, action) => {
            state.language = English
            state.checkedStatus = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilterFund.pending, (state, action) => {
                // toast.warn("applications list pending")
                state.loader = true;
            })
            .addCase(fetchFilterFund.fulfilled, (state, action) => {
                // toast.warn("applications list pending")
                state.loader = false;
            })
            .addCase(fetchFilterFund.rejected, (state, action) => {
                // toast.warn("applications list pending")
                state.loader = false;
            })
    }
}
)

export const language = state => state.languages.language

export default filterFundSlice.reducer